// src/providers/NotaProviders.js
import React from 'react';
import { NotaProvider } from '../contexts/vendas/NotaContext';
import { NotaItemProvider } from '../contexts/vendas/NotaItemContext';
import { NotaPagProvider } from '../contexts/vendas/NotaPagContext';
import { ConfigTEFProvider } from '../contexts/administrativo/ConfigTEFContext';

export default function NotaProviders({ children }) {
  return (
    <NotaProvider>
      <NotaPagProvider>
        <NotaItemProvider>     
          <ConfigTEFProvider>
            {children}        
          </ConfigTEFProvider>             
        </NotaItemProvider>
      </NotaPagProvider>
    </NotaProvider>
  );
}
